import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { InputBaseComponent } from '../input-base/input-base.component';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'input-file',
  templateUrl: './input-file.component.html',
  styleUrls: ['./input-file.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class InputFileComponent extends InputBaseComponent {

  @Output() public readonly fileNameEmitter: EventEmitter<string> = new EventEmitter<string>();
  @Output() public readonly infoEmitter: EventEmitter<{ message: string, error: boolean }> = new EventEmitter<{ message: string, error: boolean }>();
  @Input() public selectFileText?: string;
  @Input() public acceptTypes: string = '*';
  @Input() public maxSizeInMB: number = 2;
  @Input() public multipleFiles: boolean = false;
  public fileName?: string;
  public file?: File;
  public mimeType?: string;


  constructor() {
    super();
  }

  // TODO translations
  // click on fileupload-button
  public handleFileInput(target: any): void {
    const file = target.files.item(0);
    if (!file) {
      return;
    } else if (file.size > this.maxSizeInMB * 1048576) {
      this.infoEmitter.next({ message: 'Es dürfen nur Dateien mit max. 1MB hochgeladen werden. Datei zu groß', error: true });
      return;
    } /* else if (!file.type.includes('image/')) {
      this.toastr.error('Es dürfen nur Bilder hochgeladen werden.', 'Ungültiges Format');
      return;
    }*/
    this.fileName = 'Lade...';
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      this.fileName = file.name;
      if (reader?.result) {
        this.control.setValue(reader.result.toString().split('base64,')[1]);
        this.control.markAsDirty();
      }
    };
  }

}
